import React, { useState, useEffect } from "react";

function Slideshow({ images }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000); // Change image every 3 seconds

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, [images.length]);

  return (
    <div className="col-md-5 d-flex flex-column justify-content-center align-content-center flex-wrap">
      <img
        className={`img-fluid object-fit-scale images`}
        src={images[currentIndex].src}
        alt={images[currentIndex].alt || `Slide ${currentIndex + 1}`}
      />
    </div>
  );
}

export default Slideshow;
